import { makeSvgIcon } from '../makeSvgIcon'

export const pentagon = makeSvgIcon(
  <path d="M12 1L22.4616 8.60081L18.4656 20.8992H5.53436L1.53838 8.60081L12 1Z" />
)
